/**
 * A click handler that keeps a click to the element it lands on, for an
 * element drawn inside something that answers clicks of its own: a dialog's
 * card over the backdrop that closes it, a control inside a clickable row.
 */export default function stopPropagation(event){event.stopPropagation();}